import { Suspense, lazy } from "react";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ProjectCardSkeleton } from "@/components/ProjectCardSkeleton";
import { Skeleton } from "@/components/ui/skeleton";

// Lazy loading de componentes no críticos
const BenefitsSection = lazy(() => import("@/components/BenefitsSection").then(m => ({ default: m.BenefitsSection })));
const ServicesSection = lazy(() => import("@/components/ServicesSection").then(m => ({ default: m.ServicesSection })));
const SmartMatchingSection = lazy(() => import("@/components/public/SmartMatchingSection"));
const FeaturedProjectsSection = lazy(() => import("@/components/FeaturedProjectsSection"));
const ContactForm = lazy(() => import("@/components/ContactForm").then(m => ({ default: m.ContactForm })));
const CTASection = lazy(() => import("@/components/CTASection").then(m => ({ default: m.CTASection })));
const AboutSection = lazy(() => import("@/components/AboutSection").then(m => ({ default: m.AboutSection })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

const Index = () => {
  return (
    <div className="min-h-screen public-layout">
      <Header />
      <div id="inicio">
        <HeroSection />
      </div>
      
      <Suspense fallback={<div className="py-20"><Skeleton className="h-64 w-full max-w-7xl mx-auto" /></div>}>
        <BenefitsSection />
      </Suspense>

      <div id="matching">
        <Suspense fallback={<div className="py-20"><Skeleton className="h-96 w-full max-w-2xl mx-auto" /></div>}>
          <SmartMatchingSection />
        </Suspense>
      </div>
      
      <Suspense fallback={<div className="py-20"><Skeleton className="h-64 w-full max-w-7xl mx-auto" /></div>}>
        <ServicesSection />
      </Suspense>
      
      <div id="proyectos">
        <Suspense fallback={
          <section className="py-20 bg-muted/30">
            <div className="container mx-auto px-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {[1, 2, 3, 4].map((i) => (
                  <ProjectCardSkeleton key={i} />
                ))}
              </div>
            </div>
          </section>
        }>
          <FeaturedProjectsSection />
        </Suspense>
      </div>
      
      <div id="contacto">
        <Suspense fallback={<div className="py-20"><Skeleton className="h-96 w-full max-w-7xl mx-auto" /></div>}>
          <ContactForm />
        </Suspense>
      </div>
      
      <Suspense fallback={<div className="py-20"><Skeleton className="h-48 w-full max-w-7xl mx-auto" /></div>}>
        <CTASection />
      </Suspense>
      
      <div id="nosotros">
        <Suspense fallback={<div className="py-20"><Skeleton className="h-64 w-full max-w-7xl mx-auto" /></div>}>
          <AboutSection />
        </Suspense>
      </div>
      
      <Suspense fallback={<div className="py-12"><Skeleton className="h-32 w-full" /></div>}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
